import {ProductAndFeeDefintion} from 'components/service/fees/fee.types';
import nxModule from 'nxModule';
import _ from 'lodash';
import {renewedLoanCreationTypes} from 'constants/loan';

import templateUrl from './customer-loans-edit-params-and-charges.template.html';

export class CustomerLoanEditParamsAndCharges {

  constructor($location, command, notification, confirmation, customerCache, authentication, http, customerLoanCreateService, loanService) {
    this.$location = $location;
    this.command = command;
    this.notification = notification;
    this.confirmation = confirmation;
    this.customerCache = customerCache;
    this.authentication = authentication;
    this.customerLoanCreateService = customerLoanCreateService;
    this.http = http;
    this.loanService = loanService;
  }

  async $onInit()  {
    this.loan.loanTypeId = this.loan.typeId;
    this.loan.automaticTransferAgreement = this.loan.automaticTransferAgreement ? this.loan.automaticTransferAgreement : { transferStrategy: 'NONE'};

    const interestType =  this.loan.interestType || this.loan.loanType.interestType
    if (interestType === 'ADD_ON_RATE') {
      this.loan.interestRate = this.loan.monthlyInterestRate
    }

    this.onFeesAutoUpdated = message => {
      this.feesAutoUpdated = message;
    };

    const [feeDefinitions] = await Promise.all([
      this.http.get(`/products/product-fee-definitions/${this.loan.id}`).toPromise(),
      this.loadRenewedLoan()
    ]);
    const penalty = feeDefinitions.find(f => f.feeClass === 'PENALTY');
    this.penaltyDefinition = penalty;
  }

  /**
   * On release a renewal pays off the loan it was renewed from, net of the waive saved for that loan when the renewal
   * was created. Loads both the way the Renew page sets them up, so the Renewed loan tab shows the saved waive and the
   * simulation and the save include it - a save replaces the saved waive with the one it sends.
   */
  async loadRenewedLoan() {
    if (!this.isInactiveRenewal()) {
      return;
    }

    const renewedLoanId = this.loan.renewedLoanId;
    try {
      const [sourceLoan, savedWaiveRequest] = await Promise.all([
        this.loanService.getLoanForCustomer(this.customerId, renewedLoanId),
        this.http.get(`/products/loans/${renewedLoanId}/waive-request`).toPromise()
      ]);
      if (!sourceLoan) {
        throw new Error(`Renewed loan ${renewedLoanId} not found`);
      }

      this.loan.sourceLoan = sourceLoan;
      this.loan.existingAmortizationSchedule = sourceLoan.amortizationSchedule;
      // an empty response body means no waive was saved
      this.loan.waiveRequest = savedWaiveRequest || {productId: renewedLoanId, waiveParts: [], priorityAmortizationIds: []};
      this.renewedLoanLoaded = true;
    } catch (e) {
      this.notification.show('Error', 'Error fetching the renewed loan and its waive request.');
    }
  }

  isInactiveRenewal() {
    return this.loan.status === 'INACTIVE'
      && !!this.loan.renewedLoanId
      && renewedLoanCreationTypes.includes(this.loan.creationType);
  }

  showRenewedLoan() {
    return !!this.renewedLoanLoaded;
  }

  /**
   * A save of a renewal replaces its saved waive with the one sent, so without the saved waive loaded
   * a save would remove it.
   */
  isRenewedLoanPending() {
    return this.isInactiveRenewal() && !this.renewedLoanLoaded;
  }

  async updateParamsAndCharges() {
    const proceed = await this.confirmation("Are you sure you want to update the loan parameters and charges?");
    if (!proceed) {
      this.notification("No changes were made to the loan parameters and charges.");
      return;
    }

    const request = this.customerLoanCreateService.createLoanCommandInput(this.loan);
    if(this.penaltyDefinition.extraOptions?.LOAN_BOARD) {
      request.penalty = undefined;
    }

    const response = await this.command.execute("EditLoanParametersAndCharges", request).toPromise();
    if (!response.approvalRequired) {
      this.customerCache.loans(this.customerId).refetch();
      this.customerCache.customerProductFees(this.customerId, 'LOAN').refetch();
      this.authentication.permissions['CST_CREDIT_LINE_READ'] ?  this.customerCache.creditLines(this.customerId).refetch() : Promise.resolve();
      this.redirectBack();
    }
  }

  redirectBack() {
    this.$location.path(`/customer/${this.customerId}/loans/${this.loan.id}`);
  }

  showConsolidatedLoans() {
    return this.loan.creationType === 'CONSOLIDATION' && this.loan.status === 'INACTIVE';
  }

}

nxModule.component('customerLoanEditParamsAndCharges', {
  templateUrl,
  controller: CustomerLoanEditParamsAndCharges,
  bindings: {
    customerId: '<',
    loan: '<'
  }
});
